import React from 'react';

import {HomeIcon} from '../helper/HwIcon';

function Breadcrumbs({title, breadcrumb}) {
    return (
        <>
            <div className='hw-page--titlebar'>
                <ul className='breadcrumb mb-2 list-unstyled'>
                    <li className='breadcrumb-item'>
                        <a href={process.env.wordpressApiEndPoint || ''} className='text-muted text-hover-primary'><span
                            className='hw-icon hw-icon--home'><HomeIcon/></span></a>
                    </li>
                    <li className='breadcrumb-item'>{breadcrumb ?? 'Book a flight'}</li>
                </ul>
                <h1 className='h3 mb-0'>{title ?? 'Book Flights'}</h1>
            </div>
        </>
    );
}

export default Breadcrumbs;
